import React from 'react';

// components
import CommonInfoTab from "../Common/CommonInfoTab";

// icons
import SupportIcon from "@mui/icons-material/Support";

class FeatureRequestCard extends React.Component {
    render() {
        return(
            <CommonInfoTab
                groups={
                    [
                        {
                            title: this.props.featureRequest.title,
                            icon: <SupportIcon/>,
                            linkPattern: '/feature_request/detail/:linkParam',
                            linkParam: this.props.featureRequest.id,
                            flat: true,
                            fields: [
                                {
                                    title: 'Описание',
                                    value: this.props.featureRequest.desc,
                                    html: true,
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                },
                            ]
                        }
                    ]
                }
            />
        )
    }
}

export default FeatureRequestCard